import React, { useState } from 'react';

const FamilyName = ({ onBack, onSave, onComplete }) => {
  const [familyName, setFamilyName] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= 20) {
      setFamilyName(value);
      setError('');
    } else {
      setError('Family name cannot exceed 20 characters.');
    }
  };

  const handleSubmit = () => {
    if (familyName.trim()) {
      if (familyName.length > 20) {
        setError('Family name cannot exceed 20 characters.');
        return;
      }
      onSave(familyName);
    } else {
      setError('Family name cannot be empty.');
    }
  };

  return (
    <div className="h-screen w-full flex flex-col justify-between items-center bg-white pt-[26px] pr-[10px] pb-[11px] pl-[20px]">
      <div className="w-full flex items-center justify-between">
        <button
          onClick={onBack}
          className="bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <h1 className="text-[30px] leading-[33px] font-normal font-young-serif text-[#3A1A1A] pt-8 text-center">
          What's your
          <br />
          family name?
        </h1>
        <div className="w-6"></div>
      </div>

      <div className="flex flex-col items-center mt-6">
        <h2 className="text-[30px] leading-[42px] font-normal font-young-serif text-[#3A1A1A]">
          The
        </h2>
        <input
          type="text"
          value={familyName}
          onChange={handleChange}
          placeholder=""
          className="w-[23rem] bg-yellow-200 text-center text-lg h-[70px] font-medium font-young-serif text-[#3A1A1A] py-3 mt-2 mb-2 rounded-full focus:outline-none"
        />
        <h2 className="text-[30px] leading-[42px] font-normal font-young-serif text-[#3A1A1A]">
          Family
        </h2>
        {error && (
          <p className="text-red-500 text-sm mt-2">{error}</p>
        )}
      </div>

      <div className="flex justify-center mt-7 mb-2">
        <button
          onClick={handleSubmit}
          className="font-space-grotesk bg-black text-[#EEEEEE] text-md font-medium px-5 py-2.5 rounded-full hover:bg-gray-800 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default FamilyName;
